import { useQuery } from '@tanstack/react-query';
import { getAuthTokenWithProcore } from 'api/services';
import { BrokenLinkIcon } from 'library/icons';
import { CircularProgress } from 'library/loaders';
import { IllustrationView } from 'modules/shared/features/illustration';
import useAuthSelector from 'modules/shared/hooks/useAuthSelector';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authActions } from 'store/auth';

const ProcoreIllustration = () => {
    return (
        <div className="flex items-center gap-5">
            <img className="h-10" src="/logos/logo.png" alt="progressCenter" />
            <BrokenLinkIcon />
            <img className="h-10" src="/plugins-images/procore.svg" alt="progressCenter" />
        </div>
    );
};

const ProcoreEmbeddedLoginPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [searchParams] = useSearchParams();

    const tokenKey = searchParams.get('t');

    const { token } = useAuthSelector();

    const procoreEmbeddedQuery = useQuery(['procoreEmbeddedAuth', tokenKey], () => getAuthTokenWithProcore(tokenKey));

    useEffect(() => {
        if (procoreEmbeddedQuery.data) {
            dispatch(authActions.login({ token: procoreEmbeddedQuery.data.token, expiryInMinutes: -1 }));
        }

        if (token) {
            navigate('/dashboard', { replace: true });
        }
    }, [dispatch, navigate, procoreEmbeddedQuery.data, token]);

    if (procoreEmbeddedQuery.error)
        return (
            <IllustrationView
                className="justify-center h-screen"
                illustration={<ProcoreIllustration />}
                title="Invalid/Expired Key"
                message="It seems like your key is invalid or has expired. Try generating a new key from ProgressCenter."
            />
        );

    return (
        <section>
            <div className="fixed top-0 left-0 flex flex-col items-center justify-center h-screen w-full bg-card-color">
                <div className="flex items-center justify-center w-14 h-14 rounded-lg text-primary ">
                    <CircularProgress size={32} />
                </div>
            </div>
        </section>
    );
};

export default ProcoreEmbeddedLoginPage;
